import { ApiReturn, Partner, UnreadNotifications } from "../../types";
import { Notification } from "./../../types";
import API from "./../index";
import {
  GET_ALL_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS,
  GET_USER_PARTNER_INFORMATION,
  MARK_ALL_NOTIFICATIONS_AS_READ,
} from "./users.endpoint";

export const getAllNotifications = (
  partnerId?: string
): Promise<ApiReturn<Notification[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_ALL_NOTIFICATIONS.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const getUnreadNotifications = (
  partnerId?: string
): Promise<ApiReturn<UnreadNotifications>> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_UNREAD_NOTIFICATIONS.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const markAllNotificationsAsRead = (
  partnerId?: string
): Promise<ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      MARK_ALL_NOTIFICATIONS_AS_READ.replace(":partnerId", partnerId!),
      null,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const getUserPartnerInformation = (
  uid?: string | null
): Promise<ApiReturn<Partner> | null> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_USER_PARTNER_INFORMATION.replace(":uid", uid!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};
